import React, { useState } from "react";
import { Btn } from "../../components/button/Btn";
import { AddCategory, SuccessModal, Category } from "../../components/modal";
import Search from "../../components/Search";
import { TableCategory } from "../../components/Tables";

const CategoriesTable = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const categories = [
    { name: "ICAN", dateCreated: "09 May, 2024" },
    { name: "ICAN", dateCreated: "09 May, 2024" },
    { name: "ICAN", dateCreated: "09 May, 2024" },
    { name: "ICAN", dateCreated: "09 May, 2024" },
    { name: "ICAN", dateCreated: "09 May, 2024" },
    { name: "ICAN", dateCreated: "09 May, 2024" },
    { name: "ICAN", dateCreated: "09 May, 2024" },
    { name: "ICAN", dateCreated: "09 May, 2024" },
    { name: "ICAN", dateCreated: "09 May, 2024" },
    { name: "ICAN", dateCreated: "09 May, 2024" },
    { name: "ICAN", dateCreated: "09 May, 2024" },
    { name: "ICAN", dateCreated: "09 May, 2024" },
    { name: "ICAN", dateCreated: "09 May, 2024" },
    { name: "ICAN", dateCreated: "09 May, 2024" },
    // Add more categories here...
  ];

  const filteredCategories = categories.filter((category) =>
    category.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-md m-4">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-8">
          <h1 className="text-[20px] font-bold text-[#400167]">
            All Categories
          </h1>
          <Search onSearch={handleSearch} />
        </div>
        <div className="flex space-x-3">
          <AddCategoryButton />
          <AddNewCategory />
        </div>
      </div>
      <TableCategory categories={filteredCategories} />
    </div>
  );
};

export default CategoriesTable;

// Add Category Button Component
function AddCategoryButton() {
  const [categoryName, setCategoryName] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [subjects, setSubjects] = useState("");
  const [openAddCategory, setOpenAddCategory] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  const handleOpenAddCategory = () => {
    setOpenAddCategory(true);
  };

  const closeOpenCategory = () => setOpenAddCategory(false);

  const handleCreate = (ev) => {
    ev.preventDefault();
    setOpenAddCategory(false);
    setIsSuccessModalOpen(true);
  };

  const closeSuccessModal = () => setIsSuccessModalOpen(false);

  return (
    <div className="flex space-x-2">
      <Btn onClick={handleOpenAddCategory}>Add Category</Btn>
      <AddCategory isOpen={openAddCategory} onClose={closeOpenCategory}>
        <CategoryForm
          categoryName={categoryName}
          setCategoryName={setCategoryName}
          subCategory={subCategory}
          setSubCategory={setSubCategory}
          subjects={subjects}
          setSubjects={setSubjects}
          handleCreate={handleCreate}
        />
      </AddCategory>
      <SuccessModal isOpen={isSuccessModalOpen} onClose={closeSuccessModal} />
    </div>
  );
}

// Form Inputs in the Add category modal component
function CategoryForm({
  categoryName,
  setCategoryName,
  subCategory,
  setSubCategory,
  subjects,
  setSubjects,
  handleCreate,
}) {
  return (
    <div>
      <div className="mb-4">
        <label className="block text-[#400167] text-[16px] mb-2 font-satoshi font-semibold">
          Category Name
        </label>
        <input
          type="text"
          placeholder="Title"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          className="w-full p-2 border border-[#400167] rounded focus:outline-none"
        />
      </div>
      <div className="mb-4">
        <label className="block text-[#400167] mb-1 font-medium">
          Is there sub-category?{" "}
          <span className="font-light">(If yes, enter below)</span>
        </label>
        <input
          type="text"
          placeholder="Category 1"
          value={subCategory}
          onChange={(e) => setSubCategory(e.target.value)}
          className="w-full p-2 border border-[#400167] rounded focus:outline-none"
        />
      </div>
      <div className="mb-6">
        <label className="block text-[#400167] mb-1 font-semibold">
          Enter Subjects
        </label>
        <input
          type="text"
          placeholder="Subject 1"
          value={subjects}
          onChange={(e) => setSubjects(e.target.value)}
          className="w-full p-2 border border-[#400167] rounded focus:outline-none"
        />
      </div>
      <button
        onClick={handleCreate}
        className="w-[276px] py-4 px-2 bg-[#5002D0] text-white rounded-full hover:bg-purple-700 transition duration-200"
      >
        Create
      </button>
    </div>
  );
}

function AddNewCategory() {
  const [addNewCategory, setAddNewCategory] = useState(false);

  function handleAddNew() {
    setAddNewCategory(true);
  }

  function handleCloseAddNew() {
    setAddNewCategory(false);
  }

  function handleSsce() {
    alert("SSEC");
  }

  return (
    <>
      <Btn onClick={handleAddNew}>Add New</Btn>
      <Category
        title="Choose Category"
        isOpen={addNewCategory}
        onClose={handleCloseAddNew}
      >
        <ul>
          <Ssce onClick={handleSsce} />
          <li className="underline text-[#010811] text-[14px] mb-3">
            Cambridge & A-Level
          </li>
          <li className="underline text-[#010811] text-[14px] mb-3">
            Jamb & POST UTME
          </li>
          <li className="underline text-[#010811] text-[14px] mb-3">
            ICAN Certification
          </li>
          <li className="underline text-[#010811] text-[14px] mb-3">
            ICAN Certification
          </li>
        </ul>
      </Category>
    </>
  );
}

function Ssce({ onClick }) {
  return (
    <>
      <li
        onClick={onClick}
        className="underline text-[#010811] text-[14px] mb-3"
      >
        SSCE Exams
      </li>

      <Category>
        <ul>
          <li className="underline text-[#010811] text-[14px] mb-3">WASSCE</li>
          <li className="underline text-[#010811] text-[14px] mb-3">
            NECO & NECO GEC
          </li>
          <li className="underline text-[#010811] text-[14px] mb-3">
            WAEC GEC
          </li>
        </ul>
      </Category>
    </>
  );
}
